// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U3xY","colMin":"styles_colMin__3R6d9"};